import { useController } from 'react-hook-form';
import { ui } from '@procuros/datachecks';

import { useNavigationContext } from 'contexts/SchemableFormNavigationContext/SchemableFormNavigationContext';
import { DisplayModes } from 'services/webedi/types';
import { WebEDIAnnotation } from 'services/webediErrors/types';
import { DataDisplay } from 'components/Form/DataDisplay/DataDisplay';
import { MessageDropdown } from 'components/Form/MessageDropdown/MessageDropdown';
import { useInterpolatedEnumerableOptions } from 'components/SchemableForm/hooks/useInterpolatedEnumerableOptions';

type EnumerableFieldProps = {
  field: ui.EnumerableField;
  fieldId: string;
  isReadOnly: boolean;
  mode: DisplayModes;
  variant?: 'large';
};
export const EnumerableField = ({ field, fieldId, isReadOnly, mode, variant }: EnumerableFieldProps) => {
  const { field: formField } = useController({ name: fieldId });
  const { service } = useNavigationContext<WebEDIAnnotation>();
  const fieldState = service.useFieldStateFromAnnotations(fieldId);
  const popoverItem = service.useItemByFieldPath(fieldId);
  const setCurrentItem = service.setCurrentItem;
  const { options } = useInterpolatedEnumerableOptions(field.type_config);
  const formattedValue = options.find((option) => option.value === formField.value)?.label;

  if (mode === DisplayModes.view) {
    return (
      <DataDisplay
        value={formattedValue}
        label={field.label}
        error={popoverItem}
        fieldId={fieldId}
        onShowFieldErrorModal={() => popoverItem && setCurrentItem(popoverItem)}
        description={field.description}
      />
    );
  }

  return (
    <MessageDropdown
      {...formField}
      field={field}
      error={popoverItem}
      onShowFieldErrorModal={() => popoverItem && setCurrentItem(popoverItem)}
      required={field.modality === 'MANDATORY'}
      disabled={isReadOnly}
      fieldState={fieldState}
      variant={variant}
    />
  );
};
